module.exports = __webpack_public_path__ + "static/img/5.547fd38.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/11/zh/5.png
// module id = 7wL1
// module chunks = 0